import React, { useEffect, useState } from "react";
import { Route, Routes, useParams } from "react-router-dom";

import PlansPage from "@/components/screens/Plans";
import { PLAN_MESSAGES, PlanMessages } from "@/messages/plans/plan.messages";
import translationService from "@/services/translation.service";
import { Language, Translation } from "@/types/language.types";

const PlansPageComponent: React.FC = () => {
  const { lang = "PT-BR" } = useParams();
  const [messages, setMessages] = useState<Translation<PlanMessages> | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadMessages = async () => {
      try {
        const translations = await translationService.get<PlanMessages>(
          PLAN_MESSAGES,
          (lang as Language) ?? null
        );
        setMessages(translations);
      } finally {
        setLoading(false);
      }
    };

    loadMessages();
  }, [lang]);

  if (loading) {
    return null; // Loading handled by Suspense in child components
  }

  if (!messages) {
    return <div>Erro ao carregar mensagens</div>;
  }

  return (
    <Routes>
      <Route path="/:lang" element={<PlansPage messages={messages} />} />
      <Route path="/" element={<PlansPage messages={messages} />} />
    </Routes>
  );
};

export default PlansPageComponent;
